export enum CompanyTeamNotesField {
  Message = 'message',
}
